// Detect mobile device
export function detectMobile () {
	let check = false
	if (window.matchMedia('screen and (max-width: 61.999em)').matches) {
		check = true
	}
	return check
}

// IE Polyfill voor forEach
export function forEachPolyfill () {
	if (window.NodeList && !NodeList.prototype.forEach) {
		NodeList.prototype.forEach = function (callback, thisArg) {
			thisArg = thisArg || window
			for (var i = 0; i < this.length; i++) {
				callback.call(thisArg, this[i], i, this)
			}
		}
	}
}

export function includesPolyfill () {
	if (!String.prototype.includes) {
		String.prototype.includes = function (search, start) {
			'use strict'
			if (typeof start !== 'number') {
				start = 0
			}
			if (start + search.length > this.length) {
				return false
			} else {
				return this.indexOf(search, start) !== -1
			}
		}
	}
}
